import styled from "styled-components";
import { blue, orange } from "../../styles/variables.style";

export const EventWrapper = styled.div`
  padding-left: 15%;
  padding-right: 15%;
  display: flex;
  flex-direction: column;

  .allEvents,
  .allEvents div {
    width: 600px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .allEvents,
  .ant-btn {
    margin-left: auto;
    margin-right: auto;
  }

  .slick-dots li button {
    background: black;
  }
  .slick-dots .slick-active button {
    background: black !important;
  }

  .ant-carousel .slick-prev,
  .ant-carousel .slick-next {
    color: grey;
    font-size: unset;
  }

  h2,
  h3,
  h4,
  p,
  strong {
    font-family: filson-pro, sans-serif;
  }

  .content {
    margin-top: 30px;
  }

  .titleWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 60px;

    h1 {
      font-size: 42px;
      font-weight: bold;
    }

    hr {
      width: 400px;
      height: 4px;
      background: ${orange};
      border: none;
      margin-top: 10px;
      margin-bottom: 25px;
    }
  }

  h1 {
    font-size: 34px;
    margin-bottom: 0px;
  }

  h2 {
    font-size: 32px;
    line-height: 0px;
    text-align: center;
    font-weight: bold;
    margin-top: 100px;
  }

  a {
    color: ${blue};
    font-weight: bold;
  }

  .contact-us {
    background: lightgrey;
    color: black;
    margin-top: 50px;
    margin-bottom: 50px;
  }

  .eventsDescription {
    padding-left: 10%;
    padding-right: 10%;
  }

  @media (max-width: 1024px) {
    padding-left: 3%;
    padding-right: 3%;
    .titleWrapper {
      #mainTitle {
        font-size: 32px;
      }
      hr {
        width: 90%;
      }
    }
    .allEvents,
    .allEvents div {
      width: 90vw;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    h2 {
      line-height: 35px;
      margin-top: 20px;
      margin-bottom: 0px;
    }
    .eventsDescription {
      padding: 0px;
    }
    .ant-btn {
      margin: 0px;
      margin-top: 20px;
      margin-bottom: 10px;
    }
  }
`;
